// extracted by mini-css-extract-plugin
export default {"wrapper":"SOF_wrapper__0bZzH","greenArrow":"SOF_greenArrow__k6478","contentWrapper":"SOF_contentWrapper__dOfuS","formWrapper":"SOF_formWrapper__-X+b-"};